import React, { useState, useEffect } from 'react'
import { use } from 'xadmin'
import { C } from 'xadmin-ui'

import { Button, Empty, message, Form } from 'antd'
import MenuEditTree from '../components/MenuEditTree'

const MainMenuField = ({ id, data = {}, saveItem }) => {
  const [value, setValue] = useState(data.mainmenu || [])

  const onChange = mainmenu => {
    setValue(mainmenu)
  }

  const saveData = () => {
    saveItem({ id: data.id, mainmenu: value }).then(() => {
      setValue(value)
    }).catch(err => message.error(err))
  }

  return <>
    <MenuEditTree input={{ value, onChange }} />
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1rem' }}>
      <Button onClick={saveData}>保存</Button>
    </div>
  </>
}

const SettingsMenuField = ({ id, data = {}, saveItem }) => {
  const [value, setValue] = useState(data.mainmenu || [])
  const onChange = mainmenu => {
    saveItem({ ...data, mainmenu })
    setValue(mainmenu)
  }
  return <MenuEditTree input={{ value, onChange }} settings={data} type="front" />
}

export default {
  name: 'iot-menu',
  items: {
    menuItems: { type: 'array' },
    helpMenus: { type: 'array' },
    sideMenuItems: { type: 'array' },
    frontMenuItems: { type: 'array' }
  },
  'user.schema': app => ({ data: user }, cb) => {
    if (user && user.isSuper) {
      cb(null, {
        name: 'mainmenu',
        title: '前台系统菜单',
        type: 'object',
        showInList: false,
        renderComponent: MainMenuField
      })
    } else {
      let permissions = user && user.permissions
      let index = permissions && permissions.length && permissions.findIndex(item => item == 'frontSystemMenu.view')
      if (index == -1) {
        cb(null, {})
      } else {
        cb(null, {
          name: 'mainmenu',
          title: '前台系统菜单',
          type: 'object',
          showInList: false,
          renderComponent: MainMenuField
        })
      }
    }
  },
  'role.schema': app => ({ data: role }, cb) => {
    cb(null, {
      name: 'mainmenu',
      title: '前台系统菜单',
      type: 'object',
      showInList: false,
      renderComponent: MainMenuField
    })
  },
  'settings.schema': app => ({ data: settings }, cb) => {
    cb(null, {
      name: 'mainmenu',
      title: '前台系统菜单',
      parentTab: '前台配置',
      type: 'object',
      showInList: false,
      renderComponent: SettingsMenuField
    })
  }
}
